import React from "react";
import { Text } from "web/react/emo/text";
import * as styles from "./quote-text.css";

function parseQuoteText(text: string): { quote: string; author: string | null } {
    // Splits on blank lines;
    // if there's more than one paragraph, the last one is treated as the author attribution.
    const parts = text
        .replace(/\r\n/g, "\n")
        .split("\n\n")
        .map((p) => p.trim())
        .filter(Boolean);

    if (parts.length >= 2) {
        return {
            quote: parts.slice(0, -1).join("\n\n"),
            author: parts[parts.length - 1],
        };
    }
    return { quote: parts[0] ?? text, author: null };
}

export interface QuoteTextProps {
    text: string;
}

export function QuoteText({ text }: QuoteTextProps): React.ReactElement {
    const { quote, author } = parseQuoteText(text);

    return (
        <blockquote className={styles.quote}>
            <Text color="primary" textStyle="body-1">
                {quote}
            </Text>
            {author && (
                <Text color="primary" textStyle="body-bold">
                    <br />
                    {author}
                </Text>
            )}
        </blockquote>
    );
}
